import { render, staticRenderFns } from "./OrderControlHistory.vue?vue&type=template&id=445a0192&"
import script from "./OrderControlHistory.vue?vue&type=script&lang=js&"
export * from "./OrderControlHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports